import React, { FC } from 'react';
import { Select } from 'antd';

interface IOWStaticSelect {
	items: any[];
	value?: any;
	valueAccessor: (item: any) => any;
	renderRecord: (item: any) => any;
	onChange?: (value: any) => void;
	mode?: 'multiple' | 'tags';
	placeholder?: string;
	allowClear?: boolean;
	style?: any;
	disabled?: boolean;
}

// Static-list counterpart to OWAsyncSelect for use in AdvancedFilters
// filterConfig entries (component: OWStaticSelect, items: [...]): renders a
// plain antd Select from the given items instead of fetching from redux.
const OWStaticSelect: FC<IOWStaticSelect> = ({
	items,
	value,
	valueAccessor,
	renderRecord,
	onChange,
	mode,
	placeholder,
	allowClear = true,
	style,
	disabled,
}): React.ReactElement => {
	return (
		<Select
			mode={mode}
			value={value}
			onChange={onChange}
			placeholder={placeholder}
			allowClear={allowClear}
			showSearch={true}
			optionFilterProp="children"
			style={style || { width: '100%' }}
			disabled={disabled}
		>
			{(items || []).map((item) => (
				<Select.Option key={valueAccessor(item)} value={valueAccessor(item)}>
					{renderRecord(item)}
				</Select.Option>
			))}
		</Select>
	);
};

export default OWStaticSelect;
